import { Component, ElementRef, OnInit, Input } from '@angular/core';
import { Broadcaster } from '../../service/Broadcaster';
import { SingService } from '../../service/sing.service';
import { responseRemoveExpense } from 'app/components/class/http/res/response-remove-expense';
import { IndexExpense } from 'app/components/class/index-expense';
import { showAddCampaignMode } from 'app/components/class/broadcaster/add-campaign/show-add-campaign-mode';
import { updateCategories } from 'app/components/class/broadcaster/update-categories';
import { renameCategori } from 'app/components/class/broadcaster/rename/rename-categori';
import { renameProduct } from 'app/components/class/broadcaster/rename/rename-product';

@Component({
    selector: 'app-context-menu-budget',
    templateUrl: './context-menu.component.html',
    styleUrls: ['./context-menu.component.css']
})
export class ContextMenuBudget implements OnInit {

    source: any;
    open: boolean = false;
    clicked: boolean = false;
    rooftops = [];
    id = 0;
    type = '';
    month;
    year;
    quarter;
    currentMonth;
    campaigns = [];
    indexes;
    categories;
    data;

    constructor(private broadcaster: Broadcaster, private elRef: ElementRef, private httpService: SingService) { }

    ngOnInit() {
        this.broadcaster.on<any>("updateCategories").subscribe((data:updateCategories) => {
            this.categories = data.categories;
           
        })
        this.broadcaster.on<any>("sendBudgetData").subscribe(data => {
            this.month = data.date.month;
            this.year = data.date.year;
            this.quarter = data.date.quarter;
            this.categories = data.data.categories;
            this.data = data.data;
        })
        this.broadcaster.on<any>("sendNewBudgetData").subscribe(data => {
            this.month = data.date.month;
            this.year = data.date.year;
            this.quarter = data.date.quarter;
            this.data = data.data;
        })
        this.broadcaster.on<any>('openContext').subscribe(data => {
            const menu = document.getElementById('context');
            this.source = data.source;
            menu.style.left = `${data.position.x}px`;
            menu.style.top = `${data.position.y + window.pageYOffset}px`;
         
            if (data.isMedia && data.isMedia === true) {
                 this.closed();
                 return;
            }
            menu.classList.add('active');
            this.open = true
            this.rooftops = data.rooftops;
            this.id = data.id;
            this.type = data.type;
            this.indexes = data.indexes;
         

            if (data.type === "category") {
                this.elRef.nativeElement.querySelector(".campaign").classList.remove('hid');
                this.elRef.nativeElement.querySelector(".rename").classList.remove('hid');
            }
            if (data.type === "product") {
                this.elRef.nativeElement.querySelector(".rename").classList.remove('hid');
                this.elRef.nativeElement.querySelector(".add-campaign").classList.remove('hid');
            }
            if (data.type === "campaign") {

                for (let i in data.expenses) {
                    if (data.expenses[i].id > 0) {
                        this.campaigns.push(data.expenses[i])
                    }
                }
            }

        });
        this.broadcaster.on<any>('confirmRemove').subscribe(data => {
            this.confirmRemove();
        })
        this.broadcaster.on<any>('noRemove').subscribe(data => {
            this.noRemove();
        })
        document.addEventListener("click", (e) => {
         //   this.closeMenu(e.target)
         this.closeMenu(e)
        });
        window.addEventListener("contextmenu", (e) => {

        });
    }
    rename() {
        if (this.type === "category") {
            this.broadcaster.broadcast('renameCategori', new renameCategori (this.indexes.category,this.categories[this.indexes.category]));
        }
        if (this.type === "product") {

            this.broadcaster.broadcast('renameProduct', new  renameProduct(this.indexes.product,this.indexes.category,this.categories[this.indexes.category].products[this.indexes.product]));
        }
        this.closed();

    }
    closeMenu = (src) => {
       
        var clickeElIsLink = this.clickInsideElement(src, "context-link");

        if (!clickeElIsLink) {
            var button = src.which || src.button;
            if (button === 1) {
                const menu = document.getElementById('context');
        if (this.open) {
            if (src.target.classList.contains("cmenu")) {
                return
            }
            menu.classList.remove('active');
            this.elRef.nativeElement.querySelector(".campaign").classList.add('hid');
            this.open = false;
        }
            }
        }
    }
    clickInsideElement(e, className) {
        var el = e.srcElement || e.target;

        if (el.classList.contains(className)) {
            return el;
        } else {
            while (el = el.parentNode) {
                if (el.classList && el.classList.contains(className)) {
                    return el;
                }
            }
        }

        return false;
    }
    closed() {
      
        const menu = document.getElementById('context');
        menu.classList.remove('active');

        this.elRef.nativeElement.querySelector(".add-campaign").classList.add('hid');
        this.elRef.nativeElement.querySelector(".campaign").classList.add('hid');
        this.elRef.nativeElement.querySelector(".rename").classList.add('hid');
        this.open = false;
    }
    remove() {
        this.broadcaster.broadcast('remove', {
            text: "Are you Sure?",
            type: "remove"
        })
        this.closed();
    }
    confirmRemove() {
       
        if (this.type === "product") {
            let num = this.rooftops.length;
            for (let i in this.rooftops) {
                let data = {
                    year: this.year,
                    month: this.month,
                    dealerShipId: this.rooftops[i].id,
                    productId: this.id,
                    blockError: true
                }
                this.httpService.removeProduct(data).subscribe(data => {
                    num = num - 1;
                    if (num === 0) {
                        this.getData();
                    }
                }, (error) => {
                    num = num - 1;
                    if (num === 0) {
                        this.getData();
                    }
                })
            }
        }
        if (this.type === "category") {
            let num = this.rooftops.length;
            for (let i in this.rooftops) {
                let data = {
                    year: this.year,
                    month: this.month,
                    dealerShipId: this.rooftops[i].id,
                    productCategoryId: this.id,
                    blockError: true
                }
                this.httpService.removeCategory(data).subscribe(data => {
                    num = num - 1;
                    if (num === 0) {
                        this.getData();
                    }
                }, (error) => {
                    num = num - 1;
                    if (num === 0) {
                        this.getData();
                    }
                })
            }
        }
        if (this.type === 'campaign') {
            let num = this.campaigns.length;
            for (let i in this.campaigns) {
                let id = this.campaigns[i].id;
                this.httpService.removeExpense(id, true).subscribe((data:responseRemoveExpense) => {
                    num = num - 1;
                    if (num === 0) {
                        this.getData();
                    }
                }, (error) => {
                    num = num - 1;
                    if (num === 0) {
                        this.getData();
                    }
                })
            }
        }
        this.closed()
    }
    noRemove() {
     
        this.closed()
    }
    getData() {
        this.broadcaster.broadcast("updateBudget", null)
    }
    addCampaign() {
        if (this.categories[this.indexes.category].products[this.indexes.product].subproducts) {
            let data = {
                makeNew: true,
                dealerShipId: this.rooftops[0].id,
                productId: this.categories[this.indexes.category].products[this.indexes.product].id,
                categoryId: this.categories[this.indexes.category].id,
                productTitle: this.categories[this.indexes.category].products[this.indexes.product].title,
                campaign: ""
            }
            this.broadcaster.broadcast("openInfoBudget", data)

        }
        else {
            if (this.categories[this.indexes.category].products[this.indexes.product].expenses[0].id !== 0)
            {
                this.categories[this.indexes.category].products[this.indexes.product].price = Number(String(this.categories[this.indexes.category].products[this.indexes.product].targetBudget).split(',').join(''));
              
                            this.broadcaster.broadcast('showAddCampaignMode', new showAddCampaignMode( {
                                action: "show",
                                product: [this.categories[this.indexes.category].products[this.indexes.product]],
                                productId: this.categories[this.indexes.category].products[this.indexes.product].id,
                                dataId: new IndexExpense(this.indexes.category,this.indexes.product,(this.indexes.campaign === null) ? this.indexes.campaign : (-1)),
                                settings: {
                                    year: this.year,
                                    month: this.month,
                                    viewType: 'daysOfMonth',
                                    dealerShipId: this.rooftops[0].id,
                                    dealerGroupId: "5",
                                    quarter: this.quarter,
                                },
                                productCategoryId: this.categories[this.indexes.category].id
                            }));
            }
            else
            {
               document.getElementById(`${this.rooftops[0].title}-${this.categories[this.indexes.category].products[this.indexes.product].id}-over`).click();
            }
      
        }

        this.closed();





        /* if (this.categories[this.indexes.category].products[this.indexes.product].subproducts) {
             this.broadcaster.broadcast("addNewCampaign", {
                 categoryIndex: this.indexes.category,
                 productIndex: this.indexes.product,
                 data: "addNewCampaign"
             })
         } else {
             this.broadcaster.broadcast("addCampaign", {
                 data: "addcampaign",
                 categoryIndex: this.indexes.category,
                 productIndex: this.indexes.product
             })
         }*/
    }
    addProduct() {

        let id = `${this.categories[this.indexes.category].id}-addInput`;
        document.getElementById(id).classList.remove('hid');
        document.getElementById(id).focus();
        this.closed();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/budget/context-menu/context-menu.component.ts